import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { ResetUser } from '../store/user-managment.actions';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../../../utils/validation.util";


@Component({
  selector: 'app-reset-user',
  templateUrl: './reset-user.component.html',
  styleUrls: ['./reset-user.component.scss']
})
export class ResetUserComponent implements OnInit {
    resetForm: FormGroup;
    userToBeReset: any = {};
    showPassword: boolean;
    selectedMember;
    validationMsg = VALIDATION_MESSAGES;

    constructor(
        private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private store: Store<AppState>,
        private fb: FormBuilder)
    {
        this.dialogRef.disableClose = true;
        this.userToBeReset = data.userToBeReset;
        this.showPassword = false;

        this.resetForm = this.fb.group({
          email: ['', Validators.compose([
              Validators.required,
              ValidationUtil.cannotBeBlank,
              this.emailValidator,
          ])]
      });
    }
    

    ngOnInit() {
    }

    onCloseDialog(): void {
        this.dialogRef.close();
    }

    resetUser() {
      if (!this.resetForm.valid) {
          return;
      }
      const inputData = this.resetForm.value;
      const payload = {
        newEmail: inputData.email
      };
      this.store.dispatch( new ResetUser(this.userToBeReset._id, payload));
      this.dialogRef.close();
    }

    emailValidator(control: AbstractControl): { [key: string]: any } | null {
        if (control.value && control.value.trim()) {
            const valid = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/gm.test(control.value.trim());
            return valid
                ? null
                : { invalidEmail: { valid: false, value: control.value } };
        }
    }
}

